import { Injectable } from '@angular/core';
import { BaseViewModel } from '../../../../models/base/base-view-model';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { SmartFiltersDomainModel } from '../../../../domainModels/smart-filters-domain-model';
import { LoadingOptions } from '../../../../models/shared/loading-options';

@Injectable()
export class SmartFilterLineItemViewModel extends BaseViewModel {
  constructor(private smartFiltersDomainModel: SmartFiltersDomainModel) {
    super();
  }

  public loadingOpts = LoadingOptions.defaultWhiteBackground();

  private _smartFilterId = new BehaviorSubject<string>(null);

  public smartFilter$ = combineLatest([this._smartFilterId, this.smartFiltersDomainModel.curatedSmartFilters$]).pipe(
    map(([id, filters]) => filters?.find(filter => filter?.id === id))
  );

  public smartFilterTitle$ = this.smartFilter$.pipe(map(filter => filter?.name));
  public smartFilterVariantCount$ = this.smartFilter$.pipe(
    map(filter => {
      const singularOrPluralSuffix =
        filter?.appliedVariantIds?.length && filter.appliedVariantIds.length === 1 ? 'Variant' : 'Variants';
      return `${filter?.appliedVariantIds?.length} ${singularOrPluralSuffix}`;
    })
  );

  setSmartFilterId(smartFilterId: string) {
    this._smartFilterId.next(smartFilterId);
  }
}
